import React from 'react'
import SellerImg from "../assets/images/SellerImg.png";

function RealStateTransactions() {
    return (
        <div className='container px-3'>


            <div className='row'>
                <div className='col-lg-6'>
                    <div>
                        <img src={SellerImg} className='img-fluid' />
                    </div>
                </div>

                <div className="col-lg-6 px-lg-5 d-flex flex-column justify-content-center mt-5 mt-lg-0">
                    <div className="font-face-PlusJakartaSans-Bold">
                        <h1>The Real Estate Transactions</h1>

                        <div className="" style={{ borderBottom: "2px solid #E8E8E8" }}>

                            <h4 className=" py-1 font-face-PlusJakartaSans-Bold mt-3">
                                Defragmented
                            </h4>
                            <p className=" font-face-PlusJakartaSans-Regular ">
                                BASE brings all parties and services on a transaction in one platform
                            </p>


                        </div>
                        <div className="" style={{ borderBottom: "2px solid #E8E8E8" }}>

                            <h4 className=" py-1 font-face-PlusJakartaSans-Bold mt-3">
                                Demystified                            </h4>
                            <p className=" font-face-PlusJakartaSans-Regular ">
                                BASE provides a step-by step journey, easy fill smart forms, and tool tips to make the transaction simple and efficient                            </p>


                        </div>
                        <div className="" style={{ borderBottom: "2px solid #E8E8E8" }}>

                            <h4 className=" py-1 font-face-PlusJakartaSans-Bold mt-3">
                                Democratized                            </h4>
                            <p className=" font-face-PlusJakartaSans-Regular ">
                                BASE allows Seller and Buyer to communicate directly through chat functionality giving power to the users and removing expensive realtors                            </p>


                        </div>

                    </div>
                </div>


            </div>
        </div>
    )
}

export default RealStateTransactions